import { render, staticRenderFns } from "./RowAndColumnBreakpoints.vue?vue&type=template&id=a8467882&"
import script from "./RowAndColumnBreakpoints.vue?vue&type=script&lang=js&"
export * from "./RowAndColumnBreakpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports